import React, {Component} from 'react'
import {Button, Card, Tabs, Tooltip, Tag, Drawer} from 'antd'
import moment from 'moment'
import Request from '../../request'
import Emitter from '../../emitter'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'

import {getUrlPushWrapper} from "../../routes";
import Dashboard from "./index"
import Stock from "../stock/product/productList"

const {TabPane} = Tabs;


class MainDashboard extends Component {


    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.historyTable = React.createRef()
        this.state = {
            activeKey: "1",
            currentPage: 1,
            // per-product stock history (inward/outward transactions)
            historyVisible: false,
            historyData: [],
            historyProduct: '',
            historyProductId: null,
        }
    }
    apiRequest = (params) => {
        if (params.page) {
          this.state.currentPage = params.page
        }
        let currentUser = JSON.parse(window.localStorage.getItem('user'))
    
        if (currentUser && currentUser.userType === 'Dispatch') {
          params.filledBy = currentUser._id
        }
        if (!params.sortOrder) {
          params.sortField = 'createdAt'
          params.sortOrder = 'desc'
        }
    
        this.setState({ filters: { ...params } })
    
        return new Promise(async (resolve) => {
          let data = await Request.getAllStockProductList({
            ...params,
            regExFilters: ['name'],
          })
        
          this.setState({ count: data.total })
    
          resolve(data)
        })
      }
      downloadDispatch = async () => {
        this.setState({ fileDownloadLoader: true })
        // export the CURRENTLY FILTERED set (e.g. Category / search), not every
        // record — forward the table filters minus pagination, like /inward/stock
        const { page, count, results, ...filters } = this.state.filters || {}
        await Request.downloadStock({ filters })
        this.setState({ fileDownloadLoader: false })
      }

      // ---- Stock history (all inward/outward transactions for one product) ----
      openHistory = (record) => {
        if (!record || !record._id) return
        this.setState(
          {
            historyVisible: true,
            historyProduct: record.name || '',
            historyProductId: record._id,
            historyData: [],
          },
          () => {
            if (this.historyTable.current && this.historyTable.current.reload) {
              this.historyTable.current.reload()
            }
          }
        )
        // load every transaction (unpaginated) just for the lifetime totals
        Request.inwardOutwardList({
          productId: record._id,
          results: 100000,
          count: 100000,
        }).then((res) => {
          if (res && !res.error) this.setState({ historyData: res.data || [] })
        })
      }

      closeHistory = () => this.setState({ historyVisible: false })

      historyApiRequest = (params) => {
        const productId = this.state.historyProductId
        return new Promise(async (resolve) => {
          if (!productId) return resolve({ data: [], total: 0 })
          if (!params.sortOrder) {
            params.sortField = 'createdAt'
            params.sortOrder = 'desc'
          }
          let data = await Request.inwardOutwardList({
            ...params,
            productId,
            regExFilters: ['product'],
          })
          resolve(data)
        })
      }

      historyColumns = () => [
        {
          title: 'Type',
          dataIndex: 'type',
          key: 'type',
          width: 110,
          filters: [
            { text: 'Inward', value: 'Inward' },
            { text: 'Outward', value: 'Outward' },
          ],
          render: (val) => <Tag color={val === 'Inward' ? 'blue' : 'red'}>{val}</Tag>,
        },
        { title: 'Products', dataIndex: 'product', key: 'product', searchTextName: 'product' },
        { title: 'Quantity', dataIndex: 'quantity', key: 'quantity', width: 90 },
        {
          title: 'Description',
          dataIndex: 'description',
          key: 'description',
          render: (val) => val || '-',
        },
        {
          title: 'Date',
          dataIndex: 'recordDate',
          key: 'recordDate',
          searchDateName: 'recordDate',
          render: (val) => (val ? moment(val).format('lll') : '-'),
        },
        {
          title: 'Created At',
          dataIndex: 'createdAt',
          key: 'createdAt',
          searchDateName: 'createdAt',
          render: (val) => (val ? moment(val).format('lll') : '-'),
        },
      ]

      renderHistoryDrawer = () => {
        const { historyVisible, historyData, historyProduct } = this.state
        const totalIn = (historyData || [])
          .filter((d) => d.type === 'Inward')
          .reduce((s, d) => s + (Number(d.quantity) || 0), 0)
        const totalOut = (historyData || [])
          .filter((d) => d.type === 'Outward')
          .reduce((s, d) => s + (Number(d.quantity) || 0), 0)
        return (
          <Drawer
            title={`Stock History${historyProduct ? ` — ${historyProduct}` : ''}`}
            visible={historyVisible}
            onClose={this.closeHistory}
            width={860}
            destroyOnClose>
            <div style={{ marginBottom: 12 }}>
              <Tag color="blue">Total Inward Quantity: {totalIn}</Tag>
              <Tag color="red">Total Outward Quantity: {totalOut}</Tag>
              <Tag color="green">Net Quantity: {totalIn - totalOut}</Tag>
            </div>
            <TableComp
              ref={this.historyTable}
              columns={this.historyColumns()}
              apiRequest={this.historyApiRequest}
              pagination={{
                defaultPageSize: 10,
                pageSizeOptions: ['10', '20', '50', '100'],
                showSizeChanger: true,
              }}
            />
          </Drawer>
        )
      }
    // apiRequest = (params) => {
    //     if (params.page) {
    //         this.state.currentPage = params.page
    //     }

    //     return new Promise(async (resolve) => {
    //         if (!params.sortField) {
    //             params.sortField = 'stock'
    //             params.sortOrder = 'ascend'
    //         }

    //         let data = await Request.getAllStockProducts({
    //             ...params, regExFilters: ['name']
    //         })

    //         this.setState({count: data.total})
    //         resolve(data);
    //     })


    // }


    async componentDidMount() {
        let {data: categoryList} = await Request.loadCategories();

        this.setState({categoryList: categoryList})

    }


    render() {

        const {dispatch} = this.props
        const {currentPage} = this.state;

       
        const categoriesArray = this.state.categoryList && this.state.categoryList.map((item) => {
          return {
              text: item.category,
              value: item._id
          }
      });
  
      const columns = [
        {
          title: 'S.No',
          dataIndex: 'sno',
          width: 50,
          key: 'sno',
          fixed: 'left',
          render: (value, item, index) => (currentPage - 1) * 10 + index + 1,
        },
  
        {
          title: 'Products',
          dataIndex: 'name',
          key: 'name',
          searchTextName: 'name',
          width: 200,
        },
        {
          title: 'Category',
          width: 100,
          key: 'category',
          filters: categoriesArray,
  
          render: (val, record) => {
              return <div>
                  {record && record.category && record.category.category}
              </div>
          }
  
      },
      {
        title: 'Stock',
        dataIndex: 'stockQty',
        key: 'stockQty',
  
        width: 200,
        render:(val,record) => {
         
         const {stockQty,criticalValue,criticalValueTwo} = record
         if(stockQty>criticalValue && stockQty>criticalValueTwo){
          return <Tag color='#26ae60'>{stockQty}</Tag>
         }
        else if(stockQty<=criticalValue && stockQty>criticalValueTwo){
          return <Tag color='#ff8c00'>{stockQty}</Tag>
         }
          
         else {
          return <Tag color='#FF3E4D'>{stockQty}</Tag>
         }
          
          
        }
      },
        
        
        {
          title: 'Latest Inward Qty',
          dataIndex: 'inwardQty',
          key: 'inwardQty',
          render:(val,record)=>{
            if (record.inwardAddedDate !== null && record.inwardQty!==0){
              // record.inwardDate
              return <p>{record.inwardQty} ({moment(record.inwardAddedDate).format('lll')})</p>
            }
            else {
              return <p>{record.inwardQty}</p>
            }
          }
        },
        {
          title: 'Latest  Outward Qty',
          dataIndex: 'outwardQty',
          key: 'outwardQty',
          render:(val,record)=>{
            if (record.outwardAddedDate !== null && record.outwardQty!==0){
              // record.outwardDate
              return <p>{record.outwardQty} ({moment(record.outwardAddedDate).format('lll')})</p>
            }
            else {
              return <p>{record.outwardQty}</p>
            }
          }
        },
        {
          title: 'Net  Qty',
          dataIndex: 'stock',
          key: 'stock',
        },
        {
          title: 'Actions',
          key: 'actions',
          width: 90,
          render: (val, record) => (
            <Tooltip title="View stock history">
              <Button
                size="small"
                shape="circle"
                icon="history"
                onClick={() => this.openHistory(record)}
              />
            </Tooltip>
          ),
        },
      ]
        // const columns = [
        //     {
        //         title: 'S.No',
        //         dataIndex: 'sno',
        //         width: 50,
        //         key: 'sno',
        //         render: (value, item, index) => (currentPage - 1) * 10 + index + 1
        //     },
        //     {
        //         title: 'Product Name',
        //         key: 'name',
        //         width: 150,
        //         dataIndex: 'name',
        //         searchTextName: 'name'


        //     },
        //     {
        //         title: 'Category',
        //         width: 100,
        //         key: 'category',
        //         filters: categoriesArray,

        //         render: (val, record) => {
        //             return <div>
        //                 {record && record.category && record.category.category}
        //             </div>
        //         }

        //     },


        //     {
        //         title: 'Inward Total',
        //         dataIndex: 'inwardCount',
        //         width: 100,
        //         searchTextName: 'inwardCount',

        //     }, {
        //         title: 'Outward Total',
        //         dataIndex: 'outwardCount',
        //         width: 100,
        //         searchTextName: 'outwardCount',

        //     },
        //     {
        //         title: 'Net Stock',
        //         dataIndex: 'stock',
        //         width: 80,
        //         render: (val, record) => {
        //             if ((record && record.stock) <= (record && record.criticalValue)) {
        //                 return <Tag color={'red'}>{record.stock}</Tag>
        //             } else {
        //                 return <Tag>{record.stock}</Tag>
        //             }
        //         }

        //     },
        //     {
        //         title: 'Critical Value',
        //         width: 120,
        //         searchTextName: 'criticalValue',
        //         dataIndex: 'criticalValue'

        //     },

        //     {
        //         title: 'Created At',
        //         width: 120,
        //         key: 'createdAt',
        //         dataIndex: 'createdAt',
        //         sorter: true,
        //         render: (text, record) => {
        //             return (
        //                 <div>
        //                     {text ? moment(text).format('lll') : ''}
        //                 </div>
        //             )
        //         }
        //     },
        //     {
        //         key: 'actions',
        //         width: 40,
        //         title: 'Actions',
        //         render: (text, record) => {
        //             return <React.Fragment>
        //                 <Tooltip title="View Ledger">
        //                     <a href={`/stock/view/ledger?id=${record._id}`} target={'_blank'}>
        //                         <Button style={{marginLeft: '5px'}} size="small" icon={'eye'} shape={'circle'}/>
        //                     </a>
        //                 </Tooltip>
        //             </React.Fragment>
        //         }
        //     }


        // ]

        return (
            <div>
                <Tabs activeKey={this.state.activeKey} onChange={(i) => {
                    this.setState({activeKey: i})
                    if (i === "1") {
                        this.setState({key: Date.now()})
                    } else {
                        this.table.current.reload()
                    }


                }}>
                    <TabPane tab="Dashboard" key="1">
                        <Dashboard key={this.state.key}/>
                    </TabPane>

                    <TabPane tab="Stock" key="2" forceRender={true}>
                        <Card>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
            <Tooltip title="Download">
              <Button
                type="warning"
                style={{ marginTop: '6px' }}
                loading={this.state.fileDownloadLoader}
                onClick={() => {
                  this.downloadDispatch()
                }}
                icon="download">
                Download
              </Button>{' '}
            </Tooltip>
          </div>
                        <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            pagination={{
              ...this.state.pagination,
              defaultPageSize: 20,
              pageSizeOptions: ['10', '20', '50', '100'],
              showSizeChanger: true,
              ...this.props.pagination,
            }}
          />
                            {/* <TableComp ref={this.table}
                                       columns={columns}
                                       apiRequest={this.apiRequest}
                                       pagination={{
                                           ...this.state.pagination,
                                           defaultPageSize: 10,
                                           pageSizeOptions: ['10', '25', '50', '100'],
                                           showSizeChanger: true,
                                           ...this.props.pagination
                                       }}/> */}
                        </Card>
                    </TabPane>
                </Tabs>
                {this.renderHistoryDrawer()}
            </div>
        )
    }

}

export default MainDashboard

